import { useEffect, useState } from "react";
const useBrowser = () => {
    const [isTabActive, setIsTabActive] = useState(true);
    useEffect(() => {
        const onVisibilityChange = () => {
            setIsTabActive(document.visibilityState === 'visible');
        };
        document.addEventListener('visibilitychange', onVisibilityChange);
        return () => {
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, []);
    return {
        isTabActive
    };
};
export default useBrowser;
